import type { Catalogue, Locale } from '../types';
import { en } from './en';
import { fr } from './fr';

/**
 * The shipped catalogues. Adding a locale is adding a file and one line here -
 * a content change, never a code change (PRD NFR-006).
 */
export const catalogues: Readonly<Record<Locale, Catalogue>> = {
  en: en as unknown as Catalogue,
  fr,
};

export { en, fr };
